<mat-spinner style="position:fixed;top:50%;left:50%" *ngIf="!load"></mat-spinner>

<div class="lti-rp" *ngIf="load">

  <!-- Left: marketing panel -->
  <aside class="lti-rp-left">
    <div class="lti-rp-left-inner">

      <a routerLink="/" class="lti-rp-logo">
        <img src="assets/images/LTI-logo-white-v2.png" alt="LetsTimeIt" class="lti-brand-logo">

      </a>

      <div class="lti-rp-hero">
        <h1>Almost<br/>there.</h1>
        <p>Choose a strong new password to secure your account and get back to managing your events.</p>
      </div>

      <div class="lti-rp-steps">
        <div class="lti-rp-step lti-rp-step-done">
          <div class="lti-rp-step-badge">
            <mat-icon>check</mat-icon>
          </div>
          <div>
            <div class="lti-rp-step-title">Email verified</div>
            <div class="lti-rp-step-desc">We confirmed your identity.</div>
          </div>
        </div>
        <div class="lti-rp-step lti-rp-step-done">
          <div class="lti-rp-step-badge">
            <mat-icon>check</mat-icon>
          </div>
          <div>
            <div class="lti-rp-step-title">Code verified</div>
            <div class="lti-rp-step-desc">OTP matched successfully.</div>
          </div>
        </div>
        <div class="lti-rp-step lti-rp-step-active">
          <div class="lti-rp-step-badge lti-rp-step-badge-num">3</div>
          <div>
            <div class="lti-rp-step-title">Set new password</div>
            <div class="lti-rp-step-desc">Choose a strong, unique password.</div>
          </div>
        </div>
      </div>

      <div class="lti-rp-tip">
        <mat-icon>lightbulb_outline</mat-icon>
        <span>Use at least 8 characters, mixing letters, numbers, and symbols.</span>
      </div>

      <div class="lti-rp-footer">
        <span>© 2026 LetsTimeIt Inc.</span>
      </div>

    </div>
  </aside>

  <!-- Right: form panel -->
  <main class="lti-rp-right">
    <form class="lti-rp-form-wrap" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">

      <div class="lti-rp-lock-icon">
        <mat-icon>lock_reset</mat-icon>
      </div>

      <h2 class="lti-rp-title">Set new password</h2>
      <p class="lti-rp-sub">Your new password must be at least 8 characters.</p>

      <div class="lti-rp-fields">

        <div class="lti-field-wrap">
          <label class="lti-inp-label">New password</label>
          <div class="lti-input-box" [class.lti-input-invalid]="frmCtrl.password.invalid && frmCtrl.password.touched">
            <mat-icon class="lti-input-ico">lock_outline</mat-icon>
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
              [maxlength]="100" [minlength]="8" class="lti-input" placeholder="••••••••" />
            <button type="button" class="lti-eye-btn" (click)="showPassword = !showPassword" tabindex="-1">
              <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </div>
          <span class="lti-err" *ngIf="frmCtrl.password.invalid && frmCtrl.password.touched">{{errorMessage.password}}</span>
        </div>

        <div class="lti-field-wrap">
          <label class="lti-inp-label">Confirm password</label>
          <div class="lti-input-box" [class.lti-input-invalid]="frmCtrl.password_confirmation.dirty && frmCtrl.password_confirmation.touched && frmCtrl.password_confirmation.invalid">
            <mat-icon class="lti-input-ico">lock_outline</mat-icon>
            <input [type]="showConfirm ? 'text' : 'password'" formControlName="password_confirmation"
              [maxlength]="100" class="lti-input" placeholder="••••••••" />
            <button type="button" class="lti-eye-btn" (click)="showConfirm = !showConfirm" tabindex="-1">
              <mat-icon>{{showConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </div>
          <span class="lti-err" *ngIf="frmCtrl.password_confirmation.dirty && frmCtrl.password_confirmation.touched">{{errorMessage.password_confirmation}}</span>
        </div>

        <div class="lti-err-block" *ngIf="error">{{error}}</div>

        <button class="lti-submit-btn" type="submit" [disabled]="!submitable">
          <mat-spinner *ngIf="processing" [diameter]="20"
            style="--mdc-circular-progress-active-indicator-color:#0f0e0a" class="mx-auto"></mat-spinner>
          <span *ngIf="!processing">Reset password</span>
        </button>

      </div>

      <p class="lti-rp-hint">
        Remember your password? <a routerLink="/" class="lti-link">Sign in</a>
      </p>

    </form>
  </main>

</div>
